export * from "./MarketingG2Banner";